import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './Buttons.css';
import 'react-datepicker/dist/react-datepicker.css';
import MainPage from './pages/main-page';
import PageHeader from './components/header';
import PageFooter from './components/footer';
import ProductsPage from './pages/products-page';
import Details from './pages/details-page';
import TicketsPage from './pages/tickets-page';
import CartPage from './pages/cart-page';
import TextPage from './pages/text-page';
import EventPage from './pages/event-page';
import Guests from './pages/guests-page';
import CheckoutPage from './pages/checkout-page';
import PaymentPage from './pages/payment-page';
import CompletedPage from './pages/completed-page';
import LoginPage from './pages/login';
import PrivatePage from './pages/private-page';
import QRPage from './pages/qr-page';
import Modal from 'react-bootstrap/Modal';
import CommonService from './services/common.service';
import signalDispatcherInstance from './utils/signalDispatcher';
import userEventService from './services/user-event.service';

let common = new CommonService();

interface AppState {
  showSessionExpiredModal: boolean;
}

class App extends React.Component<{}, AppState> {

  constructor(props: {}) {
    super(props);
    this.state = {
      showSessionExpiredModal: false
    };
  }

  componentDidMount() {
    userEventService.init();

    if (localStorage.getItem('sessionExpired') === 'true') {
      localStorage.removeItem('sessionExpired');
      this.setState({ showSessionExpiredModal: true });
    }

    const path = window.location.pathname;
    const shouldValidate = path === '/' || path.startsWith('/hotel/') || path === '/checkout';
    const uuid = localStorage.getItem('uuid');
    if (uuid && shouldValidate) {
      common.validateUUID(uuid).then((result) => {
        if (!result.valid && result.uuid) {
          localStorage.setItem('uuid', result.uuid);
          localStorage.removeItem('cart');
          localStorage.removeItem('cartExpiryTime');
          localStorage.removeItem('orderID');
          signalDispatcherInstance.emit('resetCart');
          localStorage.setItem('sessionExpired', 'true');
          window.location.href = '/';
        }
      }).catch((error) => {
        console.error('UUID validation failed:', error);
      });
    }
  }

  render() {
    return (
      <>
        <PageHeader></PageHeader>
        <Router>
          <Routes>
            <Route path="/" element={<MainPage></MainPage>} />
            <Route path="/hotel/:id" element={<MainPage></MainPage>} />
            <Route path="/products/:id" element={<ProductsPage></ProductsPage>} />
            <Route path="/privateboat" element={<PrivatePage></PrivatePage>} />
            <Route path="/event/:id" element={<EventPage></EventPage>} />
            <Route path="/tickets/:id" element={<TicketsPage></TicketsPage>} />
            <Route path="/details/:service/:prodid/:eventid/:date/:time/:maxnum" element={<Details></Details>} />
            <Route path="/guests/:service/:id" element={<Guests></Guests>} />
            <Route path="/cart" element={<CartPage></CartPage>} />
            <Route path="/login" element={<LoginPage></LoginPage>} />
            <Route path="/checkout" element={<CheckoutPage></CheckoutPage>} />
            <Route path="/about-us" element={<TextPage pageId='about'></TextPage>} />
            <Route path="/contact-us" element={<TextPage pageId='contact'></TextPage>} />
            <Route path="/privacy-policy" element={<TextPage pageId='privacy'></TextPage>} />
            <Route path="/terms-and-conditions" element={<TextPage pageId='terms'></TextPage>} />
            <Route path="/payment" element={<PaymentPage></PaymentPage>} />
            <Route path="/completed" element={<CompletedPage></CompletedPage>} />
            <Route path="/qrcodes" element={<QRPage></QRPage>} />
          </Routes>
        </Router>
        <PageFooter></PageFooter>
        
        <Modal
          show={this.state.showSessionExpiredModal}
          onHide={() => this.setState({ showSessionExpiredModal: false })}
          centered
          contentClassName="session-expired-modal"
        >
          <Modal.Body className="session-expired-modal-body">
            <p><strong>Tisztelt Felhasználónk!</strong></p>
            <p>
              Munkamenete lejárt, így automatikusan töröltük kosarát.
              Kérjük helyezze újra a kosárba a kiválasztott termékeket!
            </p>
            <div className="text-end mt-3">
              <button
                className="btn btn-light"
                onClick={() => this.setState({ showSessionExpiredModal: false })}
              >
                Rendben
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default App;
